module.exports = __webpack_public_path__ + "img/greeting.8f06358d.gif";